import AISparkle from "../../assets/images/AISparkle.svg";
import CSS from "./styles.module.css";

const HeroText = ({ result }) => {
	return (
		<div className={`${CSS.HeroText} ${result === 3 ? CSS.HeroText2 : ""}`}>
			<h1 className={`${CSS.Text} ${result === 3 ? CSS.Text2 : ""}`}>
				{result === 3
					? "Here's your Top-notch Email Template"
					: "Free HR Email Template Generator"}
				<img src={AISparkle} alt="Free HR Email Template Generator" />
			</h1>
			<font>
				Generate personalized HR emails in seconds for seamless HR
				communications.
			</font>
		</div>
	);
};

export default HeroText;
